import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MasterDeliverySliders from '../MasterDeliverySliders'
import Block from '../Block'
import RemoveBlockButton from '../Calculator/RemoveBlockButton'
import { MASTER_DELIVERY_GROUP_TITLE } from '../../strings/titles'
import { CalculatorContext } from '../Context/CalculatorContext'
import { calculateMasterDeliveryCost } from '../../model/calculator/calculator'

const initialMasterDelivery = {
    tier1: 0,
    tier2: 0,
    tier3: 0,
    tier4: 0,
    tier5: 0,
    tier6: 0
}

const MasterDeliveryBlock = ({ cost, setCost, setShowBlock }) => {
    const { currency } = useContext(CalculatorContext)

    const [masterDelivery, setMasterDelivery] = useState({
        ...initialMasterDelivery
    })

    useEffect(() => {
        setCost(calculateMasterDeliveryCost(masterDelivery))
    }, [masterDelivery, currency, setCost])

    const handleRemoveBlock = () => {
        setCost({
            total: 0,
            sources: {}
        })
        setShowBlock(false)
    }

    return (
        <div>
            <Block
                currency={currency}
                cost={cost.total}
                title={MASTER_DELIVERY_GROUP_TITLE}
                startOpen={true}
            >
                <RemoveBlockButton onClick={handleRemoveBlock} />

                <MasterDeliverySliders
                    usage={masterDelivery}
                    onChange={setMasterDelivery}
                />
            </Block>
        </div>
    )
}

MasterDeliveryBlock.propTypes = {
    cost: PropTypes.shape({
        total: PropTypes.number,
        sources: PropTypes.objectOf(PropTypes.number)
    }),
    setCost: PropTypes.func,
    setShowBlock: PropTypes.func
}

export default MasterDeliveryBlock
